var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ol",
      { attrs: { slot: "content" }, slot: "content" },
      _vm._l(_vm.history, function(item) {
        return _c("li", { key: item.id }, [
          _vm._v(
            "\n             " +
              _vm._s(item.quName) +
              "\n              upload on " +
              _vm._s(_vm._f("DateTime")(item.createOn)) +
              "\n              "
          ),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "https://api.musubi-thai.com/public/prodtask/" +
                  item.prodTaskID +
                  "/" +
                  item.quSaveName
              }
            },
            [_c("i", { staticClass: "fa fa-download" })]
          )
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83c06fb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83c06fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/quotation-history.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-83c06fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/quotation-history.vue
// module chunks = 2 3